export default __webpack_public_path__ + "static/media/359.bcb880c6.png";